import React from "react";
import { FaCalendarAlt, FaCommentAlt, FaEye, FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { blogDetailPath } from "../../utils/seo";
import "./Blog-index.css";
import ArticleThumbnail from "../../Components/Blog/ArticleThumbnail";

const BlogCard = ({ articles = [] }) => (
  <div className="blog-list" dir="rtl">
    {articles.length === 0 ? <p className="blog-index-status">هنوز مقاله‌ای منتشر نشده است.</p> : (
      <ul className="blog-list-items">
        {articles.map((article) => (
          <li key={article.id}>
            <article className="blog-list-item">
              <Link className="blog-list-link" to={blogDetailPath(article)}>
                <h2 dir="auto">{article.title}</h2>
                <ArticleThumbnail src={article.imageUrl} />
              </Link>
              <div className="blog-list-meta">
                {article.authorName && <span className="blog-list-author"><FaUser aria-hidden="true" />{article.authorName}</span>}
                {article.dateDisplay && <time dateTime={article.date || undefined}><FaCalendarAlt aria-hidden="true" />{article.dateDisplay}</time>}
                <span><FaEye aria-hidden="true" />{(article.viewCount ?? 0).toLocaleString("fa-IR")} بازدید</span>
                <span><FaCommentAlt aria-hidden="true" />{(article.commentCount ?? 0).toLocaleString("fa-IR")} دیدگاه</span>
              </div>
            </article>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default BlogCard;
